import React from 'react';

import Delete from 'Components/Partials/Modals/Delete';
import {IndexTable} from 'Components/Utilities';

import AdminLayout from 'Pages/Admin/AdminLayout';

import AdminRatesApi from 'Services/Api/Admin/HumanResources/Rates';

export default class RatesIndex extends React.Component {
    /**
     * @var columns
     * @type {array}
     */
    columns = [
        {
            label: 'Name',
            value: 'name',
            type: 'string',
            orderable: 'name'
        },
    ];

    /**
     * @method getRowActions
     * @param {object} item
     */
    getRowActions = (item) => {
        return [
            {
                type: "link",
                to: "/admin/human-resources/rates/store/"+item.id,
                text: "Update"
            },
            {
                type: "modalTrigger",
                component: Delete,
                props: {
                    itemName: 'rate',
                    itemId: item.id,
                    onDeleteApi: AdminRatesApi.delete
                },
                text: 'Delete'
            }
        ];
    }

    /**
     * @method render
     * @return {JSX.Element}
     */
    render() {
        return (
            <AdminLayout title="HR Rates">
                <IndexTable
                    columns={this.columns}
                    displaySearchBar={false}
                    storeLink="/admin/human-resources/rates/store"
                    loadDataCallback={(data) => AdminRatesApi.get(null, data)}
                    rowActions={this.getRowActions}
                    eventApi={AdminRatesApi}
                />
            </AdminLayout>
        )
    }
}
